<span [ngClass]="status">
	{{ 'sf.shared_component.my_account.devices_section.status.' + status | translate }}
</span>
